import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";

import Toolbar from "@mui/material/Toolbar";
import { drawerWidth } from "@/themes/themeConstant";
import DashboardHeader from "../Header/DashboardHeader";
import Sidebar from "../sidebar/Sidebar";
import { Backdrop, CircularProgress, styled } from "@mui/material";
import useUser from "@/hooks/useUser";

const MainBody = styled(Box)`
  .MuiBox-root{
    
  }
`

const MainBodyWrapper = styled(Box)`
  .mainBody{
    padding: 90px 15px 50px;
    height: 100vh;
    overflow-y: auto;
    width: 100%;
    overflow-x: hidden;
    @media(max-width:575px){
      padding: 80px 15px 20px;
    }
  }

  .apexcharts-canvas{
        width: 100% !important;
      }
`

const SideBAr = styled(Box)`
.MuiDrawer-paper {
  box-shadow: 6px 0px 18px rgba(0, 0, 0, 0.06);
}
`

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  children?: JSX.Element | JSX.Element[];
  name:string;
}

export default function DashboardWrapper(props: Props) {
  const { children ,name} = props;
  const [mobileOpen, setMobileOpen] = React.useState<boolean>(false);
  // const [loader, setLoader] = React.useState(true)
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const {
    profileDetails: { isLoading, isFetching },
  } = useUser();

  const [loader, setLoader] = React.useState(true);

  // useOnlineStatus();

  React.useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 500);
  }, []);

  if (loader) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open
      >
        <CircularProgress color="error" />
      </Backdrop>
    );
  }

  return (
    <Box sx={{ display: { lg:"flex", md:"flex", xs:"block",sm:"block"} }}>
      <CssBaseline />
      <DashboardHeader onClick={handleDrawerToggle} name={name}/>

      <SideBAr sx={{display: { md: "block", sm: "none",lg:"block",xs:"none" }}}>

        <Sidebar open={mobileOpen} onClose={handleDrawerToggle} />

      </SideBAr>

      <MainBody  sx={{
            flexGrow: 1,
       
          }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
       
          }}
        >
          <MainBodyWrapper>
            <Box className="mainBody">
              {children}
            </Box>
          </MainBodyWrapper>
        </Box>
      </MainBody>
      
    </Box>
  );
}
